import React, { useEffect, useState } from 'react';
import Scheduler from '../../components/Scheduler/index';
import { useSelector, useDispatch } from 'react-redux';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PickupForm from './PickupForm';
import NotificationModal from './../../components/NotificationModal/index';
import PagePreloader from '../../components/PagePreloader/index';
import ConfirmationPopup from '../../components/ConfirmationPopup/index';
import { getPickupData, sendPickupData, setTimeProposalMode, proposeNewTime, toggleSuccessMessage } from '../../services/pickup_slot/actions';
import { cancelSchedule } from '../../services/create_schedule/actions';
import Button from '@material-ui/core/Button';
import { SuccessMessage, InfoMessage } from '../../components/Messages/index';
import ActionButton from '../../components/ActionButton/index';
import { getSchedulesJSON, hasEmptyDays } from '../../services/scheduler/utils'
import moment from 'moment';
import schedulerConstants from '../../services/scheduler/constants';
import ContactForm from '../../components/ContactForm/index';
import ContactInfo from '../../components/ContactInfo/index';
import AddressModal from '../../components/AddressForm/AddressModal';

const PickupSlot = (props) => {
    const eventId = props.match.params.guid;
    const attendeeId = props.match.params.attendeeId
    const dispatch = useDispatch();
    const schedule = useSelector(state => state.scheduler.schedule);
    var activeDay = useSelector(state => state.scheduler.activeDateSlot);
    const address = useSelector(state => state.scheduler.address);
    const [warningMessage, setWarningMessage] = useState('');
    const [cancelOpened, toggleCancelModalState] = useState(false);
    const [isSubmitted, setSubmitFlag] = useState(false);
    const [isAttendeeExistsModel, SetIsAttendeeExistsModel] = useState(false);
    const [isSloatFullModel, setIsSloatFullModel] = useState(false);
    const selectedScheduler = useSelector(state => state.scheduler.schedule);
    const isSuccesMessage = useSelector(state => state.isSuccesMessageVisible);
    const {
        pickupSchedule,
        pending,
        buyerEmail,
        calendarContent,
        isSuccesMessageVisible: isModalOpened,
        specialInstructions,
        isTimeProposal,
        isBooked,
        eventName,
        bookedAt,
        buyerSchedules,
        buyerName: defaultBuyerName = '',
        buyerPhone: defaultBuyerPhone = '',
        attendeeEmail: defaultAttendeeEmail = '',
        sellerEmail,
        sellerName = '',
        sellerPhone = '',
        attendeeSchedulesList,
        hostPhoneExtension: defaulthostPhoneExtension = '',
        BuyerPhoneExtension
    } = useSelector(state => state.slotPickupData)
    const [buyerName, setBuyerName] = useState(defaultBuyerName);
    const [buyerPhone, setBuyerPhone] = useState(defaultBuyerPhone);
    const [hostPhoneExtension, SethostPhoneExtension] = useState(defaulthostPhoneExtension);
    const [attendeeEmail, setAttendeeEmail] = useState(defaultAttendeeEmail);
    const [isFormSubmited, setIsFormSubmited] = useState(false);
    const [submitedAttendeeEmail, setSubmitedAttendeeEmail] = useState(defaultAttendeeEmail);
    const [isWaitingList, setIsWaitingList] = useState(false);
    const [selectedSlotData, setselectedSlotData] = useState(null);
    const [isSameEmail, setIsSameEmail] = useState(false);
    var hostExtension = "";
    const hasSomeSlots =
        Object.values(schedule)
            .some(el => el.length);

    useEffect(() => {
        getPickupData(eventId, attendeeId)(dispatch);
    }, [eventId, attendeeId, dispatch]);

    useEffect(() => {
        hostExtension = hostPhoneExtension;
    }, [sellerEmail]);

    useEffect(() => {
        if (hasEmptyDays(schedule)) {
            setWarningMessage('You have not selected time slots for some of your available dates.');
        } else {
            setWarningMessage('');
        }

    }, [schedule, attendeeSchedulesList])

    useEffect(() => {
        clearAllContactControls();
    }, [attendeeSchedulesList])

    const clearAllContactControls = () => {
        setSubmitedAttendeeEmail(attendeeEmail);
        setBuyerName("");
        setBuyerPhone("");
        setAttendeeEmail("");
        SethostPhoneExtension("")
        setIsWaitingList(false);
        setselectedSlotData(null);
    }

    const handleChange = (flag) => {
        SetIsAttendeeExistsModel(flag);
    }

    const handleFullSlotChange = (flag) => {
        setIsSloatFullModel(flag);
    }



    const getContactInfo = () => {
        const info = {};
        if (buyerName) {
            info.buyerName = buyerName;
        }

        if (buyerPhone) {
            info.buyerPhone = buyerPhone;
        }

        if (hostPhoneExtension) {
            info.attendeePhoneExtension = hostPhoneExtension;
        }

        return info;
    }


    const isSlotsFull = (dateSlot, timeSlot) => {
        let isFull = false;
        try {
            timeSlot = timeSlot[0].slotTime;
            let numberOfAttendeesFound = 0;
            let totalSlots = 0;
            let numberOfWatingAttendees = 0;
            var allDates = Object.keys(pickupSchedule);
            if (pickupSchedule !== undefined && pickupSchedule !== null && allDates.length > 0) {
                allDates.map((item, index) => {
                    if (dateSlot === item) {
                        var schedule = pickupSchedule[item]
                        for (var i = 0; i < schedule.length; i++) {
                            if (schedule[i].slotTime === timeSlot) {
                                totalSlots = schedule[i].seats;

                            }
                        }
                    }
                });
            }

            if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {
                attendeeSchedulesList.map((item, index) => {
                    //if (item.schedules) {
                    //    let parsedSchedules = JSON.parse(item.schedules);
                    //    if (parsedSchedules) {
                    //        for (let p = 0; p < parsedSchedules.length; p++) {
                    //            if (parsedSchedules[p].date === dateSlot) {
                    //                if (parsedSchedules[p].time) {
                    //                    for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                    //                        if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                    //                            numberOfAttendeesFound++;
                    //                        }
                    //                    }
                    //                }
                    //            }
                    //        }
                    //    }
                    //}
                });
            }

            if (numberOfAttendeesFound !== 0) {
                if ((parseInt(totalSlots) - numberOfAttendeesFound) === 0) {
                    isFull = true;
                }
            }
        }
        catch (e) {
        }
        return isFull;
    }



    const handleSubmit = (formData) => {
        //const scheduleJSON = getSchedulesJSON(pickupSchedule[activeDay]);
        var scheduleJSON = "";
        if (attendeeId) {
            var currentAttendee = getCurrentAttendee(attendeeId);
            if (currentAttendee !== undefined) {
                scheduleJSON = JSON.parse(currentAttendee.schedules);
            }
        }
        else {
         scheduleJSON = getSchedulesJSON(schedule);
        }
        const contactInfo = getContactInfo();
        if (isTimeProposal) {
            setSubmitFlag(true);
            if (hasEmptyDays(schedule)) return;
            proposeNewTime({
                eventId,
                buyerSchedules: scheduleJSON,
                ...contactInfo,
            })(dispatch);
        } else {
            var isValid = true;
            if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {
                attendeeSchedulesList.map((item, index) => {
                    if (item.isCancel !== true) {
                        if (item.attendeeEmail === attendeeEmail && (item.isConfirm === true || (attendeeId === undefined && item.isWaiting === true))) {
                            isValid = false;
                        }
                    }
                });
            }

            if (isValid) {
                const { date, time } = scheduleJSON[0] || {};
                // if (!getRemainingAndWaitingSlotsCount()) {
                const requestData = {
                    datetime: (new Date(`${date} ${time[0].slotTime.split(' ')[0]}`)).toISOString(),
                    buyerEmail: attendeeEmail,//formData.email,
                    eventId,
                    attendeeId: attendeeId,
                    //schedules: getSchedulesJSON(schedule),
                    schedules: scheduleJSON,
                    ...contactInfo,
                }
                sendPickupData(requestData)(dispatch);
                //}
                //else {
                //    setIsSloatFullModel(true);
                //}
            }
            else {
                SetIsAttendeeExistsModel(true);
            }
        }
    }

    const handleCancel = () => {
        cancelSchedule({ eventId, attendeeId })(dispatch);
        toggleCancelModalState(false);
    };

    const IsAllow = (isSetControl) => {
        var isAllow = !isBooked;
        var currentAttendee = getCurrentAttendee(attendeeId);
        var IsSlotFull = getRemainingAndWaitingSlotsCount();
        var IsAllConfirmSlotFull = AllConfiremSlotCount();
        if (currentAttendee !== undefined && currentAttendee.isWaiting) {
            if (isSetControl) {
                setBuyerName(currentAttendee.attendeeName)
                setBuyerPhone(currentAttendee.attendeePhone)
                setAttendeeEmail(currentAttendee.attendeeEmail)
                SethostPhoneExtension(currentAttendee.phoneExtension)
                if (IsAllConfirmSlotFull) {
                    setWarningMessage('You are in waiting list.');
                }
            }
            isAllow = true;


        }
        else if (IsSlotFull === false && currentAttendee !== undefined && currentAttendee.isConfirm) {
            isAllow = false;
        }
        else if (IsSlotFull) {
            isAllow = false;
        }
        return isAllow;
    }

    const IsShowConfirmForm = (isSetControl) => {
        var isAllow = true;
        var currentAttendee = getCurrentAttendee(attendeeId);

        if (currentAttendee !== undefined && currentAttendee.isWaiting) {
            if (isSetControl) {
                var IsAllConfirmSlotFull = AllConfiremSlotCount();
                if (IsAllConfirmSlotFull) {
                    isAllow = false;
                }
            }
        }

        return isAllow;
    }

    const isSelectedSlot = () => {
        var currentAttendee = getCurrentAttendee(attendeeId);
        var IsSlotSelected = false;
        if (selectedScheduler != null) {
            var scheduleJSON = getSchedulesJSON(selectedScheduler);
            if (scheduleJSON.length > 0) {
                IsSlotSelected = true;
            }
        }

        if (!IsSlotSelected && currentAttendee !== undefined) {
            IsSlotSelected = IsAllow(false);
        }
        return IsSlotSelected;
    }

    const onChange = (name) => (value) => {
        if (name == "hostPhoneExtension") {
            value = value.replace(/[^0-9 ()+]/ig, '')
            SethostPhoneExtension(value)
        }
        else {
            value = value.replace(/[^A-Z a-z]/ig, '')
            setBuyerName(value)
        }

    };

    const contactFormRenderer = () => {
        return (
            <ContactForm
                name={buyerName}
                setName={onChange(setBuyerName)}
                phone={buyerPhone}
                setPhone={setBuyerPhone}
                email={attendeeEmail}
                setAttendeeEmail={(e) => { setAttendeeEmail(e); setIsFormSubmited(false)}}
                isAttendee={(sellerEmail !== undefined && sellerEmail !== null && sellerEmail !== "") ? true : false}
                isFormSubmited={isFormSubmited}
                extension={hostPhoneExtension}
                isSameEmail={isSameEmail}
                setExtension={onChange('hostPhoneExtension')}
            />
        );
    };
    
    const handleFormSubmited = (isFormSubmited) => {
        setIsFormSubmited(isFormSubmited)
    }
    const handleSameEmail = (isSameEmail) => {
        setIsSameEmail(isSameEmail)
    }
    const renderSubmitForm = () => {
        var isAllow = IsAllow(true);
        //!buyerSchedules && isAllow
        
        return isAllow && (

            <>
                {contactFormRenderer()}
                
                {!AllConfiremSlotCount(true) && (
                    <PickupForm
                        email={buyerEmail}
                        inactive={!hasSomeSlots}
                        onSubmit={handleSubmit}
                        submitTitle={isTimeProposal && 'Propose Event Date/Time'}
                        warningMessage={isSubmitted && isTimeProposal && warningMessage}
                        disableMessage={(buyerName && attendeeEmail && isSelectedSlot() ? "" : "Please fill all required fileds.")}
                        attendeeEmail={attendeeEmail}
                        handleFormSubmited={handleFormSubmited}
                        handleSameEmail={handleSameEmail}
                        isWaitingList={isWaitingList}
                        sellerEmail={sellerEmail}
                    />
                )
                }
            </>
        );
    }

    const renderPageActions = () => {
        if (isBooked || isTimeProposal || buyerSchedules) return null;

        return (
            <div className='page-actions'>
                <ActionButton
                    onClick={() => {
                        dispatch(setTimeProposalMode(true))
                        dispatch({ type: schedulerConstants.RESET_SCHEDULER_STATE })
                    }}
                    title='Propose New Time'
                />
            </div>
        );
    }

    const getRemainingAndWaitingSlotsCount = () => {
        let numberOfAttendeesFound = 0;
        let numberOfConfrimAttendees = 0;
        let numberOfWatingAttendees = 0;
        var dateSlot = "";
        var timeSlot = "";
        var currentAttendee = getCurrentAttendee(attendeeId)
        let isSlotFull = false;
        if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {
            if (currentAttendee !== undefined) {
                var currentAttendeeSchdeule = JSON.parse(currentAttendee.schedules);
                if (currentAttendeeSchdeule !== undefined) {
                    dateSlot = currentAttendeeSchdeule[0].date;
                    timeSlot = currentAttendeeSchdeule[0].time[0].slotTime;
                }
            }
            if (selectedSlotData !== undefined && selectedSlotData !== null) {
                dateSlot = selectedSlotData.dateSlot;
                timeSlot = selectedSlotData.timeSlot.slotTime;
            }
            attendeeSchedulesList.map((item, index) => {
                //if (item.isConfirm === true || item.isWaiting === true) {
                //    numberOfConfrimAttendees = (item.isConfirm == true ? numberOfConfrimAttendees + 1 : numberOfConfrimAttendees);
                //    numberOfWatingAttendees = (item.isWaiting == true ? numberOfWatingAttendees + 1 : numberOfWatingAttendees);
                //    numberOfAttendeesFound++;
                //}

                if (item.schedules) {
                    let parsedSchedules = JSON.parse(item.schedules);
                    if (parsedSchedules) {
                        for (let p = 0; p < parsedSchedules.length; p++) {
                            if (parsedSchedules[p].date === dateSlot) {
                                if (parsedSchedules[p].time) {
                                    for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                                        if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                                            //numberOfAttendeesFound++;

                                            if (item.isConfirm === true || item.isWaiting === true) {
                                                numberOfConfrimAttendees = (item.isConfirm == true ? numberOfConfrimAttendees + 1 : numberOfConfrimAttendees);
                                                numberOfWatingAttendees = (item.isWaiting == true ? numberOfWatingAttendees + 1 : numberOfWatingAttendees);
                                                numberOfAttendeesFound++;
                                            }

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }

        getCustomTimeslots().map((el, index) => {
            if (el.slotTime === timeSlot) {
                if ((parseInt(el.seats) + parseInt(el.waitingseats)) === numberOfAttendeesFound) {
                    isSlotFull = true;
                }
            }
        });
        return (isSlotFull);
    }

    const AllConfiremSlotCount = () => {
        let numberOfAttendeesFound = 0;
        let isSlotFull = false;
        var dateSlot = "";
        var timeSlot = "";
        var currentAttendee = getCurrentAttendee(attendeeId)
        if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {

            if (currentAttendee !== undefined) {
                var currentAttendeeSchdeule = JSON.parse(currentAttendee.schedules);
                if (currentAttendeeSchdeule !== undefined) {
                    dateSlot = currentAttendeeSchdeule[0].date;
                    timeSlot = currentAttendeeSchdeule[0].time[0].slotTime;
                }
            }

            attendeeSchedulesList.map((item, index) => {


                if (item.schedules) {
                    let parsedSchedules = JSON.parse(item.schedules);
                    if (parsedSchedules) {
                        for (let p = 0; p < parsedSchedules.length; p++) {
                            if (parsedSchedules[p].date === dateSlot) {
                                if (parsedSchedules[p].time) {
                                    for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                                        if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                                            if (item.isConfirm === true) {
                                                numberOfAttendeesFound++;
                                            }

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }

        getCustomTimeslots().map((el, index) => {
            if (el.slotTime === timeSlot) {
                if (parseInt(el.seats) === numberOfAttendeesFound) {
                    isSlotFull = true;
                }
            }
        });

        return (isSlotFull);
    }

    const getRemainingSlots = (dateSlot, timeSlot, totalSlots, waitingseats) => {
        var isWaitigList = false;
        let numberOfAttendeesFound = 0;
        let numberOfConfrimAttendees = 0;
        let numberOfWatingAttendees = 0;
        if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {
            attendeeSchedulesList.map((item, index) => {
                //if (item.isConfirm === true) {
                //    numberOfAttendeesFound++;
                //}

                if (item.schedules) {
                    let parsedSchedules = JSON.parse(item.schedules);
                    if (parsedSchedules) {
                        for (let p = 0; p < parsedSchedules.length; p++) {
                            if (parsedSchedules[p].date === dateSlot) {
                                if (parsedSchedules[p].time) {
                                    for (let i = 0; i < parsedSchedules[p].time.length; i++) {
                                        if (parsedSchedules[p].time[i].slotTime === timeSlot) {
                                            if (item.isConfirm === true || item.isWaiting === true) {
                                                numberOfConfrimAttendees = (item.isConfirm == true ? numberOfConfrimAttendees + 1 : numberOfConfrimAttendees);
                                                numberOfWatingAttendees = (item.isWaiting == true ? numberOfWatingAttendees + 1 : numberOfWatingAttendees);
                                                numberOfAttendeesFound++;
                                            }

                                            //numberOfAttendeesFound++;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            });
        }

        if (parseInt(totalSlots) === numberOfConfrimAttendees && numberOfWatingAttendees <= parseInt(waitingseats)) {
            isWaitigList = true;
        }

        //if (numberOfAttendeesFound >= parseInt(totalSlots) && numberOfAttendeesFound < (parseInt(totalSlots) + parseInt(waitingseats))) {
        //    isWaitigList = true;
        //}
        return isWaitigList;
        
    }

    const CheckWaitingList = (dateSlot, timeSlot) => {
        setIsWaitingList(getRemainingSlots(dateSlot, timeSlot.slotTime, timeSlot.seats, timeSlot.waitingseats));
        setselectedSlotData({ dateSlot: dateSlot, timeSlot: timeSlot });
    }

    const getCurrentAttendee = (aid) => {
        var attendee = undefined;
        if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {
            attendeeSchedulesList.map((item, index) => {
                if (item.attendeeId === aid) {
                    attendee = item;
                    return attendee;
                }
            });
        }

        return attendee;
    }

    const getCurrentAttendeeByEmail = (email) => {
        var attendee = undefined;
        if (attendeeSchedulesList !== undefined && attendeeSchedulesList !== null && attendeeSchedulesList.length > 0) {
            attendeeSchedulesList.map((item, index) => {
                if (item.attendeeEmail === email && (item.isConfirm === true || item.isWaiting === true)) {
                    attendee = item;
                    return attendee;
                }
            });
        }

        return attendee;
    }
    const renderLogger = () => {
        //if (isBooked) {
        //    return (
        //        <InfoMessage
        //            logger
        //            title={(
        //                <span>
        //                    Email Notification with {eventName} event details was sent to {buyerEmail}.
        //    </span>
        //            )}
        //        />
        //    );
        //}
        //Email Notification with {eventName} event details was sent to {buyerEmail}. on {moment(moment.utc(bookedAt).toDate()).local().format('MM/DD/YYYY HH:mm A')}.
        return buyerSchedules && (
            <InfoMessage
                logger
                title={(
                    <span>
                        Email Notification with {eventName} event details was sent to {buyerEmail}.
          </span>
                )}
            />
        );
    }

    if (pending) {
        return <PagePreloader />
    }

    const getCustomTimeslots = () => {

        var obj = attendeeSchedulesList;

        if (isTimeProposal) return null;

        if (attendeeId) {
            var currentAttendee = getCurrentAttendee(attendeeId);
            if (currentAttendee !== undefined) {
                var currentAttendeeSchdeule = JSON.parse(currentAttendee.schedules);
                if (currentAttendeeSchdeule !== undefined) {
                    activeDay = currentAttendeeSchdeule[0].date;
                    return pickupSchedule[currentAttendeeSchdeule[0].date];
                }
            }
        }

        return pickupSchedule[activeDay] || [];
    }

    const getTitle = () => {
        if (isBooked) {
            var currentAttendee = getCurrentAttendee(attendeeId);
            //return <span>{eventName} Event was successfully scheduled</span>
            return <span> Welcome back, {currentAttendee !== undefined ? currentAttendee.attendeeName : ""}</span>
        }
        return isTimeProposal
            ? 'Propose Event Date/Time'
            : `${buyerSchedules ? 'Proposed Event Date/Time' : 'Confirm Participation'}`
    };

    const IsConfirmAttendee = () => {
        var IsConfirm = false;
        var currentAttendee = getCurrentAttendeeByEmail(submitedAttendeeEmail);

        if (currentAttendee !== undefined && currentAttendee.isConfirm) {
            IsConfirm = true;
            
        }

        return IsConfirm;
    }
    return (
        <div className='page pickup-slot'>
            {buyerSchedules && !isBooked && (
                <SuccessMessage
                    title={
                        <span>{eventName} Event proposed Date/Time was successfully sent</span>
                    }
                />
            )}
            <div className='page-bar'>
                {isBooked && (getTitle())
                }
                {
                    !isBooked && (
                        <h3 className='page-title'><DateRangeIcon />
                            {getTitle()}
                        </h3>
                    )
                }
                {/*<h3 className="user-title">{eventName} Event</h3>*/}
                {/*renderPageActions()*/}
            </div>
            {

                <Scheduler
                    customTimeSlots={getCustomTimeslots()}
                    hoursMultiselect={isTimeProposal}
                    submitSenderer={renderSubmitForm}
                    readOnly={buyerSchedules || isBooked}
                    attendeeSchedulesList={attendeeSchedulesList}
                    specialInstructions={specialInstructions}
                    isSlotsFull={getRemainingAndWaitingSlotsCount()}
                    isBooked={isBooked}
                    attendeeId={attendeeId}
                    eventId={eventId}
                    CheckWaitingList={(day, time) => CheckWaitingList(day, time)}
                    isHost={false}
                />
            }

            {
                isBooked && !IsAllow(false) && (
                    <div className="cancel-attendee" style={{ marginBottom: '15px' }}>
                        <ActionButton onClick={() => toggleCancelModalState(true)} title='CANCEL MY ATTENDANCE' />
                    </div>
                )

            }

            <div className='scheduler'>
                <div className='scheduler__left'>


                    {address && (
                        <>
                            <h3 className='page-subtitle'>Event address:</h3>
                            <AddressModal
                                defaultAddress={address}
                                readOnly
                            />
                        </>
                    )}
                    {!getRemainingAndWaitingSlotsCount() && specialInstructions && (
                        <>
                            {
                                //<h3 className='page-subtitle'>Event Instructions:</h3>
                                //<div className="event-text">{specialInstructions}</div>
                            }
                            {

<span></span>                            
                            //<div className="event-instructions-attendee-view">Event Instructions:</div>
                            //<div>{specialInstructions}</div>
                            }
                        </>
                    )}
                    
                    <ContactInfo
                        title='Host Contact Information'
                        email={sellerEmail}
                        name={sellerName}
                        phone={sellerPhone}
                        extension={hostExtension != undefined && hostExtension != "" ? hostExtension : defaulthostPhoneExtension}
                        isAttendeeView={true}
                    />
                </div>
            </div>

            {renderLogger()}

            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage
                        title="Confirmed Attendee"
                    />
                )}
                descriptionRenderer={() => (
                    <div className='notification-description'>
                        You have already confirmed your participation.
          </div>
                )}
                isOpened={isAttendeeExistsModel}
                handleClose={() => {
                    handleChange(false);
                }}
            />

            <NotificationModal
                titleRenderer={() => (
                    <SuccessMessage
                        title="Slot Full"
                    />
                )}
                descriptionRenderer={() => (
                    <div className='notification-description'>
                        Selected slot has been full.
          </div>
                )}
                isOpened={isSloatFullModel}
                handleClose={() => {
                    handleFullSlotChange(false);
                }}
            />

            <NotificationModal
                titleRenderer={() => (
                    //<SuccessMessage title='Event was successfully scheduled' />
                    <SuccessMessage title={IsConfirmAttendee() ? 'Your participation to the event is confirmed.' : 'You have been added to the waitlist and will be notified when slots become available.'} />
                )}
                descriptionRenderer={() => (
                    ""
                    //         calendarContent && (<div className='notification-description'>
                    //            <Button
                    //                endIcon={<DateRangeIcon />}
                    //                onClick={() => {
                    //                    if (typeof window.navigator.msSaveBlob !== 'undefined') { // IE
                    //                        var blob = new Blob([calendarContent], { type: 'text/calendar' });
                    //                        window.navigator.msSaveBlob(blob, 'event.ics');
                    //                    } else {
                    //                        window.open("data:text/calendar;charset=utf8," + escape(calendarContent));
                    //                    }
                    //                }}
                    //                className='submit-button'
                    //            >
                    //                Download iCalendar
                    //</Button>
                    //        </div>
                    //        )

                )}
                isOpened={isModalOpened}
                handleClose={() => dispatch(toggleSuccessMessage(false))}
            />

            <ConfirmationPopup
                title={'Confirm cancelation'}
                description={'Are you sure you want to cancel your attendance?'}
                handleConfirm={handleCancel}
                handleClose={() => toggleCancelModalState(false)}
                opened={cancelOpened}
            />
        </div>
    )
}

export default PickupSlot;